const modelImprovementsTooltipContent = `This list shows your models that need most improvements in terms of publishing 
  details. The <span class="requires-attention">red</span> numbers indicate which area needs improvements so your model 
  presentation would be more attractive to the potential customers and generate more sales. Ideally this list should be 
  empty.`

export default modelImprovementsTooltipContent
